import { useMemo } from 'react';
import { t } from 'i18next';
import { Shapes } from 'lucide-react';

import { formatUtils } from '@/lib/utils';
import { FlowStatus } from '@activepieces/shared';
import { piecesHooks } from '@/features/pieces/lib/pieces-hook';
import { DataTableFilter } from '@/components/ui/data-table';
import { PieceMetadataModelSummary } from '@activepieces/pieces-framework';

type FlowFilterKeys = 'name' | 'status' | 'steps';

export const useFlowFilters = () => {
  const { pieces } = piecesHooks.usePieces({ includeHidden: false });

  const filters = useMemo(() => {
    const pieceOptions = pieces?.map(piece => ({
      label: piece.displayName,
      value: piece.name
    })) || [];

    return [
      {
        type: 'input',
        title: t('Flow name'),
        accessorKey: 'name',
        options: [],
      },
      {
        type: 'select',
        title: t('Status'),
        accessorKey: 'status',
        options: Object.values(FlowStatus).map((status) => ({
          label: formatUtils.convertEnumToHumanReadable(status),
          value: status,
        })),
      },
      {
        type: 'select',
        title: t('Applications'),
        accessorKey: 'steps',
        options: pieceOptions,
        icon: Shapes,
      },
    ] satisfies DataTableFilter<FlowFilterKeys>[];
  }, [pieces]);

  return { filters };
};